/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
/* eslint-disable no-console */
/* eslint-disable prefer-spread */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-var */
/* eslint-disable no-undef */

// slick init

require("@aspen/Aspen/MarkupScripts/slick.js")

export default function InitBrandSlickCarousel() {

  const interval = setInterval(() => {
    if (window === undefined || window.jQuery === undefined || window.jQuery.fn === undefined || window.jQuery.fn.slick === undefined) {
      return true;
    }
    const $ = window.jQuery;

    window.jQuery('.as-brand-carousel').slick({
      slidesToScroll: 1,
      rows: 0,
      slidesToShow: 5,
      prevArrow: '<button class="slick-prev">Previous</button>',
      nextArrow: '<button class="slick-next">Next</button>',
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
          variableWidth: true,
          arrows: false,
          infinite: false,
        }
      },
      ]
    });
    clearInterval(interval);
  }, 1000);
}

export function InitProductSlickCarousel(slidesToScroll: number, id: string) {

  const interval = setInterval(() => {
    if (window === undefined || window.jQuery === undefined || window.jQuery.fn === undefined || window.jQuery.fn.slick === undefined) {
      return true;
    }
    const elementId = id ? `#${id}` : '';
    if (window.jQuery(`${elementId}.as-history-carousel`).length === 0) {
      return true;
    }
    if (window.jQuery(`${elementId}.as-history-carousel.slick-initialized`).length > 0) {
      clearInterval(interval);
      return true;
    }
    const $ = window.jQuery;
    window.jQuery(`${elementId}.as-history-carousel`).slick({
      slidesToScroll: 1,
      rows: 0,
      slidesToShow: slidesToScroll,
      prevArrow: '<button class="slick-prev">Previous</button>',
      nextArrow: '<button class="slick-next">Next</button>',
      responsive: [{
        breakpoint: 1140,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
          variableWidth: true,
          arrows: false,
          infinite: false,
        }
      }
      ]
    });
    clearInterval(interval);
  }, 1000);
}
export function UnSlick(selector: string) {
  const interval = setInterval(() => {
    if (window === undefined || window.jQuery === undefined || window.jQuery.fn === undefined || window.jQuery.fn.slick === undefined) {
      return true;
    }
    if (window.jQuery(selector).length === 0) {
      return true;
    }
    if (window.jQuery(`${selector}.slick-initialized`).length > 0) {
      window.jQuery(selector).slick('unslick');
      clearInterval(interval);
      return true;
    }
  }, 1000);
}
export function InitProductDetailSlickCarousel(slidesToScroll = 1, thumbnailsToShow = 1) {

  const interval = setInterval(() => {
    if (window === undefined || window.jQuery === undefined || window.jQuery.fn === undefined || window.jQuery.fn.slick === undefined) {
      return true;
    }
    if (window.jQuery('.as-poduct-detail-slider').length === 0 || window.jQuery('.as-poduct-detail-slider-nav').length === 0) {
      return true;
    }
    if (window.jQuery(`.as-poduct-detail-slider.slick-initialized`).length > 0 && window.jQuery(`.as-poduct-detail-slider-nav.slick-initialized`).length > 0) {
      return true;
    }
    const $ = window.jQuery;
    if (window.jQuery(`.as-poduct-detail-slider.slick-initialized`).length === 0) {
      window.jQuery('.as-poduct-detail-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 0,
        infinite: false,
        autoplay: false,
        prevArrow: '<button class="slick-prev">Previous</button>',
        nextArrow: '<button class="slick-next">Next</button>',
        asNavFor: '.as-poduct-detail-slider-nav',
        responsive: [{
          breakpoint: 768,
          settings: {
            autoplay: false,
            autoplaySpeed: 500,
          }
        }]
      });
      window.jQuery('.as-poduct-detail-slider').on('beforeChange', function (event: any, slick: any, currentSlide: any, nextSlide: any) {
        if (nextSlide === slick.slideCount - 1) {
          window.jQuery('.as-poduct-detail-slider').slick('slickPause');
        }
      });
    }

    if (window.jQuery(`.as-poduct-detail-slider-nav.slick-initialized`).length === 0) {
      window.jQuery('.as-poduct-detail-slider-nav').slick({
        slidesToShow: thumbnailsToShow,
        rows: 0,
        slidesToScroll: 1,
        asNavFor: '.as-poduct-detail-slider',
        focusOnSelect: true,
        infinite: false,
        prevArrow: '<button class="slick-prev">Previous</button>',
        nextArrow: '<button class="slick-next">Next</button>'
      });
    }
    clearInterval(interval);
  }, 100);
}


export function InitSlickCarousel() {

  const interval = setInterval(() => {
    if (window === undefined || window.jQuery === undefined || window.jQuery.fn === undefined || window.jQuery.fn.slick === undefined) {
      return true;
    }
    const $ = window.jQuery;

    window.jQuery('.as-hero-slider').slick({
      slidesToScroll: 1,
      rows: 0,
      prevArrow: '<button class="slick-prev">Previous</button>',
      nextArrow: '<button class="slick-next">Next</button>'
    });


    window.jQuery('.as-history-carousel').slick({
      slidesToScroll: 1,
      rows: 0,
      slidesToShow: 4,
      prevArrow: '<button class="slick-prev">Previous</button>',
      nextArrow: '<button class="slick-next">Next</button>',
      responsive: [{
        breakpoint: 1140,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
          variableWidth: true,
          arrows: false,
          infinite: false,
        }
      }
      ]
    });
    window.jQuery('.as-poduct-detail-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0,
      infinite: false,
      autoplay: false,
      prevArrow: '<button class="slick-prev">Previous</button>',
      nextArrow: '<button class="slick-next">Next</button>',
      asNavFor: '.as-poduct-detail-slider-nav',
      responsive: [{
        breakpoint: 768,
        settings: {
          autoplay: true,
          autoplaySpeed: 500,
        }
      }]
    });
    window.jQuery('.as-poduct-detail-slider').on('beforeChange', function (event: any, slick: any, currentSlide: any, nextSlide: any) {
      if (nextSlide === slick.slideCount - 1) {
        window.jQuery('.as-poduct-detail-slider').slick('slickPause');
      }
    });
    window.jQuery('.as-poduct-detail-slider-nav').slick({
      slidesToShow: 3,
      rows: 0,
      slidesToScroll: 1,
      asNavFor: '.as-poduct-detail-slider',
      focusOnSelect: true,
      infinite: false,
      prevArrow: '<button class="slick-prev">Previous</button>',
      nextArrow: '<button class="slick-next">Next</button>'
    });
    clearInterval(interval);
  }, 1000);
}